import { Stack, styled, Box } from '@mui/material'
import { Card } from '../../../../../../components'

export const Container = styled(Stack)`
  padding: 0 16px;
  flex: 1;
  overflow: auto;
`

export const BinSuggestionsCardContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  overflow: auto;
`

export const Header = styled(Stack)`
  flex-direction: row;
  font-size: 13px;
  gap: 8px;
  width: 100%;
  height: 40px;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.primary};
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.05),
    0 1px 3px rgba(238, 237, 237, 0.05);
`

export const HeaderSectionTitle = styled(Box)`
  color: ${({ theme }) => theme.palette.text.primary};
`

export const Body = styled(Stack)`
  padding: 16px 0;
  gap: 10px;
  flex: 1;
  overflow: auto;
`

export const SuggestionItemContainer = styled(Stack)`
  height: 90px;
  width: 100%;
  border-radius: 5px;
  flex-direction: row;
  flex-shrink: 0;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.palette.customGrey.two};
`

export const SuggestionItemControls = styled(Stack)`
  height: 100%;
  min-width: 135px;
  max-width: 155px;
  flex-shrink: 0;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background: ${({ theme }) => theme.palette.customGrey.one};
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  gap: 9px;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 1;
  }
`

export const SuggestionItemSection = styled(Stack)`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.text.primary};
  justify-content: center;
  align-items: center;
  height: 100%;
`
export const SuggestionItemSliderContainer = styled(Stack)`
  justify-content: center;
  align-items: center;
  min-width: 150px;
  flex: 1;
  padding: 0 24px;
`
